import { Box } from '@mui/material';
import styles from './main-footer.module.scss';
export const MainFooter = () => {
  return (
    <Box id='contacts' className={styles.footerContainer} component='footer'>
      <h2>Контакты</h2>
      <div className={styles.footerContacts}>
        <span>
          <span className={styles.footerIcon}>📧</span> E-mail:
          <a href='mailto:info@tlspoisk.ru'>info@tlspoisk.ru</a>
        </span>
        <span>
          <span className={styles.footerIcon}>📞</span> Телефон:
          <a href='tel:+79226274545'>+79226274545</a>
        </span>
        <span>
          <span className={styles.footerIcon}>📱</span> Telegram:
          <a target='_blank' rel='noreferrer' href='https://t.me/+79226274545'>
            +79226274545
          </a>
        </span>
      </div>
    </Box>
  );
};
